import React, { Component } from "react";
import Header from "./layout/Header";
import Footer from "./layout/Footer";
import { message } from "antd";
import Bridge from "./utils/Bridge";
import { RESEARCH_TYPE } from "./utils/consts";
import SpeechAboutMe from "./screens/speech/SpeechAboutMe";
import LEStudyAboutMe from "./screens/leStudy/LEStudyAboutMe";

import englishJson from "./utils/language/leStudy/english.json";
import spanishJson from "./utils/language/leStudy/spanish.json";
import noLanguageJson from "./utils/language/leStudy/noLanguage.json";

export default class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: "",
      ecas_user_type: "",
    };
  }
  componentDidMount() {
    this.get_demographic_percentage();
  }
  get_demographic_percentage = () => {
    let params = "?eals_id=" + localStorage.getItem("ap_eals_id");
    if (RESEARCH_TYPE == "Asymptomatic Study") {
      Bridge.demographics
        .get_percentage(params)
        .then((response) => {
          this.setState({ loading: false });
          if (response.status == "1") {
            if (response.percentage != 100) {
              window.location.assign("/dashboard");
              return;
            } else {
              this.setState({ percentage: response.percentage });
            }
          }
        })
        .catch((error) => {
          message.warning("Please try again!!", error);
          this.setState({ loading: false });
        });
    } else if (RESEARCH_TYPE == "ECAS Study") {
      Bridge.demographics.ecas_study
        .get_percentage(params)
        .then((response) => {
          this.setState({ loading: false });
          if (response.status == "1") {
            if (response.percentage != 100) {
              window.location.assign("/dashboard");
              return;
            } else {
              this.setState({
                percentage: response.percentage,
                ecas_user_type: response.ecas_user_type,
              });
            }
          }
        })
        .catch((error) => {
          message.warning("Please try again!!", error);
          this.setState({ loading: false });
        });
    } else if (RESEARCH_TYPE == "LE Study") {
      params =
        "?eals_id=" +
        localStorage.getItem("ap_eals_id") +
        "&relation_to_als=" +
        localStorage.getItem("ap_relation_to_als");
      Bridge.demographics.le_study
        .get_percentage(params)
        .then((response) => {
          this.setState({ loading: false });
          if (response.status == "1") {
            if (response.percentage != 100) {
              window.location.assign("/dashboard");
              return;
            } else {
              this.setState({
                percentage: response.percentage,
                ecas_user_type: response.ecas_user_type,
              });
            }
          }
        })
        .catch((error) => {
          message.warning("Please try again!!", error);
          this.setState({ loading: false });
        });
    }
  };
  selectUserType = (param) => {
    this.setState({
      active: param,
    });
  };
  continue = () => {
    if (!this.state.active) {
      message.warning("Please select account");
      return;
    }
  };
  render() {
    const formData =
      RESEARCH_TYPE === "LE Study"
        ? this.props.language === "English"
          ? englishJson
          : this.props.language === "Spanish"
            ? spanishJson
            : noLanguageJson
        : englishJson;
    return (
      <div>
        <Header />
        <div className="main-content demographics-wrapper pt-0">
          <div className="container">
            <div className="row">
              <div className="col-lg-8 m-auto">
                <a href="/dashboard" className="dashboard-back-arrow" style={{ width: "fit-content" }}>
                  <box-icon
                    name="chevron-left"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                  {formData.page.backButtonTextDashboard}
                </a>
                <h2 className="mt-2">{formData.page.sectionNames.aboutMe}</h2>
                <br />
                {RESEARCH_TYPE == "modality.ai" ? (
                  <SpeechAboutMe />
                ) : RESEARCH_TYPE == "LE Study" ? (
                  <LEStudyAboutMe language={this.props.language} />
                ) : (
                  <div>
                    <div className="single-account">
                      <a
                        href="/personal-details"
                        style={{ textDecoration: "none" }}
                      >
                        <div className="block">
                          <div className="d-flex align-items-center">
                            <h4 className="mb-0 pb-0">Personal Information</h4>
                            <div className="completed-per yes">Completed</div>
                          </div>
                          <a href="/personal-details" className="update-button">
                            NEXT{" "}
                            <box-icon
                              name="chevron-right"
                              color="#fff"
                              style={{ position: "relative", top: 0 }}
                            ></box-icon>
                          </a>
                        </div>
                      </a>
                    </div>
                    {RESEARCH_TYPE == "ECAS Study" && (
                      <div className="single-account">
                        <a
                          href="/ecas-symptom-onset"
                          style={{ textDecoration: "none" }}
                        >
                          <div className="block">
                            <div className="d-flex align-items-center">
                              <h4 className="mb-0 pb-0">Symptom Onset</h4>
                              <div className="completed-per yes">Completed</div>
                            </div>
                            <a
                              href="/ecas-symptom-onset"
                              className="update-button"
                            >
                              NEXT{" "}
                              <box-icon
                                name="chevron-right"
                                color="#fff"
                                style={{ position: "relative", top: 0 }}
                              ></box-icon>
                            </a>
                          </div>
                        </a>
                      </div>
                    )}
                    <div className="single-account">
                      <a
                        href="/gender-race-ethnicity-details"
                        style={{ textDecoration: "none" }}
                      >
                        <div className="block">
                          <div className="d-flex align-items-center">
                            <h4 className="mb-0 pb-0">
                              Gender, Race, and Ethnicity
                            </h4>
                            <div className="completed-per yes">Completed</div>
                          </div>
                          <a
                            href="/gender-race-ethnicity-details"
                            className="update-button"
                          >
                            NEXT{" "}
                            <box-icon
                              name="chevron-right"
                              color="#fff"
                              style={{ position: "relative", top: 0 }}
                            ></box-icon>
                          </a>
                        </div>
                      </a>
                    </div>
                    <div className="single-account">
                      <a
                        href="/language-education-occupation-details"
                        style={{ textDecoration: "none" }}
                      >
                        <div className="block">
                          <div className="d-flex align-items-center">
                            <h4 className="mb-0 pb-0">
                              Language, Education, and Occupation
                            </h4>
                            <div className="completed-per yes">Completed</div>
                          </div>
                          <a
                            href="/language-education-occupation-details"
                            className="update-button"
                          >
                            NEXT{" "}
                            <box-icon
                              name="chevron-right"
                              color="#fff"
                              style={{ position: "relative", top: 0 }}
                            ></box-icon>
                          </a>
                        </div>
                      </a>
                    </div>
                    <div className="single-account">
                      <a
                        href="/physical-charachteristics"
                        style={{ textDecoration: "none" }}
                      >
                        <div className="block">
                          <div className="d-flex align-items-center">
                            <h4 className="mb-0 pb-0">
                              Physical Characteristics
                            </h4>
                            <div className="completed-per yes">Completed</div>
                          </div>
                          <a
                            href="/physical-charachteristics"
                            className="update-button"
                          >
                            NEXT{" "}
                            <box-icon
                              name="chevron-right"
                              color="#fff"
                              style={{ position: "relative", top: 0 }}
                            ></box-icon>
                          </a>
                        </div>
                      </a>
                    </div>
                    <div className="single-account">
                      <a
                        href="/medical-history"
                        style={{ textDecoration: "none" }}
                      >
                        <div className="block">
                          <div className="d-flex align-items-center">
                            <h4 className="mb-0 pb-0">Medical History</h4>
                            <div className="completed-per yes">Completed</div>
                          </div>
                          <a href="/medical-history" className="update-button">
                            NEXT{" "}
                            <box-icon
                              name="chevron-right"
                              color="#fff"
                              style={{ position: "relative", top: 0 }}
                            ></box-icon>
                          </a>
                        </div>
                      </a>
                    </div>
                    <div className="single-account">
                      <a
                        href="/family-history"
                        style={{ textDecoration: "none" }}
                      >
                        <div className="block">
                          <div className="d-flex align-items-center">
                            <h4 className="mb-0 pb-0">
                              Family History of Neurodegenerative Disease
                            </h4>
                            <div className="completed-per yes">Completed</div>
                          </div>
                          <a href="/family-history" className="update-button">
                            NEXT{" "}
                            <box-icon
                              name="chevron-right"
                              color="#fff"
                              style={{ position: "relative", top: 0 }}
                            ></box-icon>
                          </a>
                        </div>
                      </a>
                    </div>
                    <div className="single-account">
                      <a
                        href="/additional-health-info"
                        style={{ textDecoration: "none" }}
                      >
                        <div className="block">
                          <div className="d-flex align-items-center">
                            <h4 className="mb-0 pb-0">
                              Additional Health Info
                            </h4>
                            <div className="completed-per yes">Completed</div>
                          </div>
                          <a
                            href="/additional-health-info"
                            className="update-button"
                          >
                            NEXT{" "}
                            <box-icon
                              name="chevron-right"
                              color="#fff"
                              style={{ position: "relative", top: 0 }}
                            ></box-icon>
                          </a>
                        </div>
                      </a>
                    </div>
                    {RESEARCH_TYPE == "Asymptomatic Study" && (
                      <div className="single-account">
                        <a
                          href="/genetic-testing-and-gene-mutation"
                          style={{ textDecoration: "none" }}
                        >
                          <div className="block">
                            <div className="d-flex align-items-center">
                              <h4 className="mb-0 pb-0">
                                Genetic Testing and Gene Mutation
                              </h4>
                              <div className="completed-per yes">Completed</div>
                            </div>
                            <a
                              href="/genetic-testing-and-gene-mutation"
                              className="update-button"
                            >
                              NEXT{" "}
                              <box-icon
                                name="chevron-right"
                                color="#fff"
                                style={{ position: "relative", top: 0 }}
                              ></box-icon>
                            </a>
                          </div>
                        </a>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}
